import React, { useContext } from 'react';
import { IconButton, Text } from '@perch-labs/shrike';
import { formatDate } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { Container } from 'styles';
import { CleanKwh } from 'contexts/clean-kwh';
import { CardHeader } from './selector.style';

const getCopy = copyFor('modules.usageSummary');

export const Selector = () => {
  const { cleanKwh, next, nextDisabled, previous, previousDisabled } =
    useContext(CleanKwh);

  const startDate = formatDate(cleanKwh.startDate, { format: 'MMM d' });
  const endDate = formatDate(cleanKwh.endDate, { format: 'MMM d' });
  const title = `${startDate} - ${endDate}`;
  const ariaTitle = getCopy('ariaTitle', { range: title });

  return (
    <CardHeader>
      <Text textStyle="heading700" tag="h1" aria-label={ariaTitle}>
        {title}
      </Text>
      <Container>
        <IconButton
          aria-label={getCopy('aria.buttons.previous')}
          disabled={previousDisabled}
          icon="ChevronLeftCircleInverted"
          onClick={previous}
        />
        <IconButton
          aria-label={getCopy('aria.buttons.next')}
          disabled={nextDisabled}
          icon="ChevronRightCircleInverted"
          margin={{ left: '16px' }}
          onClick={next}
        />
      </Container>
    </CardHeader>
  );
};
